import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import ComparisonGraph from '../Graphs/comparison_graph';
import { AssetsService, DeviceDataOverrideService, DevicesService } from '../../services';
import { GraphDataConverter } from '../../helpers';
import i18next from "i18next";

const AssetComparisonReportResults = ({ currentGrouping, query }) => {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        setLoading(true);

        let { dateRange, startDate, deviceIds, measurementIds, displayNameToMeasurementId, deviceDataType } = query;

        const start = currentGrouping.timezone ? moment(startDate, "L").tz(currentGrouping.timezone).startOf("day").utc().valueOf() : moment(startDate, "L").startOf("day").utc().valueOf();
        var end, startAtDate, endAtDate;

        if (dateRange.value === 0) {
            //day report
            end = moment(start).add(1, 'day')
        } else if (dateRange.value === 1) {
            //week report
            end = moment(start).add(1, 'week')
        } else if (dateRange.value === 2) {
            //month report
            end = moment(start).add(1, 'month')
        }

        startAtDate = start.valueOf();
        endAtDate = end.valueOf();

        if (measurementIds) {
            AssetsService.getMeasureComparisonReport(startAtDate, endAtDate, measurementIds).then((response) => {
                let readings = [];
                Object.keys(response.report).forEach((measurementId) => {
                    const reportValues = response.report[measurementId];
                    const displayName = displayNameToMeasurementId[measurementId];
                    reportValues.forEach((reading) => {
                        reading.deviceName = displayName;
                        readings.push(reading);
                    });
                });

                const timeframeInSeconds = (endAtDate - startAtDate) / 1000;
                const reportData = GraphDataConverter.convertReadingDataToGraphData(
                    deviceDataType.token,
                    currentGrouping.timezone,
                    readings,
                    endAtDate,
                    timeframeInSeconds
                );

                setReportData(reportData);
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            });
        } else {
            DevicesService.getDeviceComparisonReport(startAtDate, endAtDate, deviceIds, deviceDataType.id).then(response => {
                let timeframeInSeconds = (endAtDate - startAtDate) / 1000;
                const reportData = GraphDataConverter.convertReadingDataToGraphData(
                    deviceDataType.token,
                    currentGrouping.timezone,
                    response.report,
                    endAtDate,
                    timeframeInSeconds
                );

                setReportData(reportData);
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            });
        }
    }, [query, currentGrouping]);

    if (loading) {
        return (<div className="loader">{ i18next.t('loading') }</div>);
    } else if (reportData && reportData.length > 0) {
        return (
            <div className="op-content-box">
                <div style={{height: 550, padding: 0}}>
                    <ComparisonGraph 
                        data={reportData} 
                        yAxisLabel={i18next.t([`device-data-display-types.${DeviceDataOverrideService.getOverrideForDisplayToken(query.deviceDataType.token)}`, `device-data-types.${query.deviceDataType.token}`])} 
                    />
                </div>
            </div>
        )
    } else {
        return (
            <div className="chart-data op-content-box">
                <p>{ i18next.t('messages.no-readings-error') }</p>
            </div>
        )
    }
};

export default AssetComparisonReportResults;
